if (!customElements.get('product-section-modal')) {
  class ProductSectionModal extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[modal-close]')
      this.wrapper = this.querySelector('.Modal__Overlay')

      this.onCloseModal = this.onCloseModal.bind(this)
    }

    connectedCallback() {
      this.button.addEventListener('click', this.onCloseModal)
      this.wrapper.addEventListener('click', this.onCloseModal)
    }

    onCloseModal() {
      const modal = this.querySelector('.product-section-modal')
      modal.classList.remove('Modal__Overlay--after-open')
    }
  }

  customElements.define('product-section-modal', ProductSectionModal);
}